// extracted by mini-css-extract-plugin
export var brand = "_5j-8";
export var compact = "_5j-5";
export var extraSmall = "_5j-6";
export var icon = "_5j-0";
export var large = "_5j-3";
export var light = "_5j-1";
export var medium = "_5j-4";
export var outline = "_5j-a";
export var primaryDark = "_5j-9";
export var primaryLight = "_5j-7";
export var primaryModern = "_5j-b";
export var success = "_5j-2";